import { Injectable } from '@angular/core';
import { HttpClient , HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { DataService } from '../../../services/data.service';
import { BusinessSubcriptionRequest } from '../../../POS/models/business-subcription-request';
import { Employee } from '../../../POS/models/employee';
import { CommonFunctionService, UserMerchantData, UserPOSData} from '../../../services/Common/common-function.service';
import { map } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  userId: any;
  token;
  headers: any;
  constructor(private service: DataService, private http: HttpClient, private common: CommonFunctionService) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
  }
  AddEmployee(data) {
    this.GetGeaderdetails();
    return this.http.post<Employee>(environment.AddEmployeeUrl, data, { headers: this.headers });
  }
  UpdateEmployee(data) {
    this.GetGeaderdetails();
    return this.http.post<Employee>(environment.UpdateEmployeeUrl, data, { headers: this.headers });
  }
  GetEmployeeDetail(data) {
    this.GetGeaderdetails();
    return this.http.get<Employee>(environment.GetEmployeeDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId + "&id=" + data.id, { headers: this.headers })
      .pipe(map(response => response));
  }
  GetEmployeeIDDetail(data) {
    this.GetGeaderdetails();
    return this.http.get<Employee>(environment.GetEmployeeDetail1Url + "?PosSubscriptionId=" + data.PosSubscriptionId + "&id=" + data.id, { headers: this.headers })
    .pipe(map(response => response));
  }

  GetEmployeeEmaildetails(data) {
    this.GetGeaderdetails();
    return this.http.get<Employee>(environment.GetEmployeeEmailDetail + "?PosSubscriptionId=" + data.PosSubscriptionId + "&email=" + data.Email + "&Mobilenumber=" + data.MobileNumber, { headers: this.headers })
    .pipe(map(response => response));
  }
  GetEmployeeMobiledetails(data) {
    this.GetGeaderdetails();
    return this.http.get<Employee>(environment.GetEmployeeMobileDetail + "?PosSubscriptionId=" + data.PosSubscriptionId + "&email=" + data.Email + "&Mobilenumber=" + data.MobileNumber, { headers: this.headers })
    .pipe(map(response => response));
  }


  getMerchantServicesAndFees(data, resellerid) {
    this.GetGeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.getMerchantFeeServicesListSetupUrl + '?merchantkeyId=' + data + "&resellerId=" + resellerid +"&LoginUserId="+merchantdata.UserId, { headers: this.headers })
    .pipe(map(response => response));
  }
  GetEmployeeListUrl(data) {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.GetEmployeeListUrl + "?posSubscriptionId=" + data, { headers: this.headers })
  }
  FilteringEmployeeDetails(PosSubscriptionId, Fromdate1, todate1, ename, eid, eemail, emobile) {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.FilteringEmployeeDetails + "?PosSubscriptionId=" + PosSubscriptionId + "&fromdate=" + Fromdate1 + "&todate=" + todate1 + "&employeeName=" +
      ename + "&employeeid=" + eid + "&employeeemail=" + eemail + "&employeemobile=" + emobile, { headers: this.headers })

  }
  GetGeaderdetails() {
    let loggedUsername = this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));

  }
}
